// Hex mirror of the CSS custom properties defined on `.dashboard-viz` in
// ExaminerDashboard.vue. ApexCharts renders its own SVG/canvas outside that
// scoped stylesheet's cascade, so it needs literal color values rather than
// var(...) references. Keep these in sync if the palette in
// ExaminerDashboard.vue's <style> block ever changes.
export const PALETTE = {
  series1: '#2a78d6',
  series2: '#eb6834',
  good: '#0ca30c',
  warning: '#fab219',
  critical: '#d03b3b',
  neutral: '#c3c2b7',
  gridline: '#e1e0d9',
  textMuted: '#898781',
  textSecondary: '#52514e',
};

// Distinct, high-attention colors for individually-flagged series in a
// many-line chart (e.g. one line per "behind pace" trainee) - warm hues,
// deliberately far from the muted grey used for de-emphasized lines.
export const EMPHASIS_COLORS = ['#d03b3b', '#eb6834', '#b8860b', '#c026d3', '#9333ea', '#be123c'];

// De-emphasized line color for series that aren't the current focus (e.g.
// on-track trainees in a chart highlighting only those behind pace).
export const MUTED_LINE_COLOR = 'rgba(137, 135, 129, 0.35)';

// For a donut/stacked-bar whose segments are plain categories with no
// inherent good/bad meaning (e.g. one slice per task scope code) - unlike
// `toneColor`'s fixed 4-5 semantic colors, this cycles through enough
// visually-distinct hues that a chart with ~10-12 categories doesn't repeat
// colors across unrelated slices.
export const CATEGORICAL_COLORS = [
  '#2a78d6', // blue
  '#eb6834', // orange
  '#0ca30c', // green
  '#b8860b', // dark goldenrod
  '#9333ea', // purple
  '#0f9c9c', // teal
  '#d03b3b', // red
  '#5b6bc0', // indigo
  '#c026d3', // magenta
  '#7c5a3a', // brown
  '#4b7a3f', // olive
  '#54606e', // slate
];

export function categoricalColor(index) {
  return CATEGORICAL_COLORS[index % CATEGORICAL_COLORS.length];
}

export function toneColor(tone) {
  switch (tone) {
    case 'good': return PALETTE.good;
    case 'warning': return PALETTE.warning;
    case 'critical': return PALETTE.critical;
    case 'accent': return PALETTE.series1;
    default: return PALETTE.neutral;
  }
}
